<template>
    <section class="space-y-1">
        <form-label>Compare</form-label>
        <div v-if="subject.wire" class="flex items-center justify-between gap-2 text-xs">
            <button v-if="subject.kind === 'gpio'" class="truncate text-left hover:text-ui-active" title="Select the GPIO entity node"
                @click="logic.select(page, 'node', subject.node.id)">GPIO {{ subject.node?.data?.entity || '(no entity selected)' }}</button>
            <span v-else class="truncate">{{ objectLabel }}</span>
            <button class="text-red-300 hover:text-red-200" title="Compare the event value instead"
                @click="logic.removeWire(page, subject.wire.id)">×</button>
        </div>
        <p v-else class="text-xs text-gray-300">
            The value of the event. Wire a UI object or GPIO entity to <em>Compare</em> to compare its value instead.
        </p>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { useLogicStore } from '../../stores/logicStore.js';
import { getFlowSubject } from '../../logic/logicFlow.js';

/** What a condition or switch compares: the event value, or the object or GPIO entity wired to it. */
const props = defineProps({
    page: { type: Object, required: true },
    graph: { type: Object, required: true },
    node: { type: Object, required: true },
    context: { type: Object, required: true },
});
const logic = useLogicStore();

const subject = computed(() => getFlowSubject(props.graph, props.node.id, props.context));
const objectLabel = computed(() => {
    const object = subject.value.object;
    if (!object) return 'missing object';
    return `${object.obj} p${props.page.haspid}b${object.haspid}${object.comment ? ` — ${object.comment}` : ''}`;
});
</script>
